const th = {
  game: `เกม`,
  games: `เกม`,
  sport: `กีฬา`,
  center: `ศูนย์`,
  mines: `เหมือง`,
  crash: `ชน`,
  lucky_colour: `สีโชคดี`,
  dice: `ลูกเต๋า`,
  limbo: `ลิมโบ`,
  lucky_gift: `ของขวัญโชคดี`,
  all_games: `เกมทั้งหมด`,
  game_history: `ประวัติการเล่นเกม`,
  coupon_code: `รหัสคูปอง`,
  telegram: `เทเลแกรม`,
  customer_service: `บริการลูกค้า`,
  player: `ผู้เล่น`,
  winner: `ผู้ชนะ`,
  all_bets: `เดิมพันทั้งหมด`,
  my_bets: `เดิมพันของฉัน`,
  name: `ชื่อ`,
  time: `เวลา`,
  bet_amount: `จำนวนเงินเดิมพัน`,
  prediction: `การคาดการณ์`,
  payout: `การจ่ายเงิน`,
  login: `เข้าสู่ระบบ`,
  register: `ลงทะเบียน`,
  username_placeholder: `ชื่อผู้ใช้`,
  please_input_your_x: `กรุณากรอก {{x}} ของคุณ`,
  verification_code: `รหัสยืนยัน`,
  press_get_code: `กดปุ่ม GET CODE เพื่อรับรหัสยืนยันทาง SMS`,
  otp_sent: `ส่งรหัสยืนยันแล้ว! กรุณากรอกรหัสยืนยันด้านล่างเพื่อดำเนินการต่อ`,
  your_otp_expire: `รหัส OTP ของคุณจะหมดอายุใน`,
  get_code: `รับรหัส`,
  didnt_receive: `ไม่ได้รับข้อความ?`,
  send_again: `ส่งอีกครั้ง`,
  captcha: `CAPTCHA`,
  forgot_password: `ลืมรหัสผ่าน`,
  minor_note: `เพื่อเข้าชมเว็บไซต์นี้ กรุณายืนยันว่าคุณอายุเกิน 18 ปีและยอมรับ`,
  terms_of_service: `ข้อกำหนดในการให้บริการ`,
  by_signing_in: 'โดยการเข้าสู่ระบบหรือสมัครสมาชิก คุณยอมรับกับ',
  dont_have_account: `ยังไม่มีบัญชี?`,
  sign_up: `สมัครสมาชิก`,
  username: `ชื่อผู้ใช้`,
  email: `อีเมล`,
  full_name: `ชื่อเต็ม`,
  confirm_18: `ฉันยืนยันว่าฉันอายุ 18 ปีและได้อ่าน`,
  already_have_account: `มีบัญชีอยู่แล้ว?`,
  share: `แชร์`,
  deposit: `ฝากเงิน`,
  bonus: `โบนัส`,
  app: `แอป`,
  load_more: `โหลดเพิ่มเติม`,
  details: `รายละเอียด`,
  helps: `ช่วยเหลือ`,
  kyc_policy: `นโยบาย KYC`,
  privacy_policy: `นโยบายความเป็นส่วนตัว`,
  responsible_gaming: `การเล่นเกมอย่างรับผิดชอบ`,
  terms_and_condition: `ข้อกำหนดและเงื่อนไข`,
  faq: `คำถามที่พบบ่อย`,
  about_us: `เกี่ยวกับเรา`,
  amount: `จำนวน`,
  extra: `เพิ่มเติม`,
  deposit_bonus: `โบนัสฝากเงิน`,
  do_not_participate: `ไม่เข้าร่วมโปรโมชั่น`,
  payment_problem: `ปัญหาการชำระเงิน`,
  click_for_help: `คลิกเพื่อขอความช่วยเหลือ`,
  deposit_notes: `หมายเหตุการฝาก`,
  available_balance: `ยอดเงินที่มีอยู่`,
  withdraw: `ถอนเงิน`,
  withdrawal_notes: `หมายเหตุการถอน`,
  withdrawal_note1: `จำนวนการถอนในปัจจุบัน`,
  withdrawal_note1_1: `วีไอพี`,
  withdrawal_note2: `ค่าธรรมเนียมการถอน:`,
  min: `ขั้นต่ำ:`,
  max: `สูงสุด:`,
  opening_times: `เวลาทำการ:`,
  withdrawal_note3: `1. เวลาถอนที่เร็วที่สุดภายใน 10 นาที`,
  withdrawal_note4: `2. กรุณาตรวจสอบข้อมูลการถอนของคุณให้ถูกต้อง หากข้อมูลการถอนผิด อาจทำให้เงินของคุณสูญหาย`,
  withdrawal_note5: `3. หากคุณมีคำถามใด ๆ กรุณาติดต่อเราได้ตลอดเวลา`,
  notifications: `การแจ้งเตือน`,
  invalid_x: `{{x}} ไม่ถูกต้อง`,
  captcha_not_match: `Captcha ไม่ตรงกัน`,
  invalid_x_must_be_atleast_y_characters: `{{x}} ไม่ถูกต้อง ต้องมีอย่างน้อย {{y}} ตัวอักษร`,
  x_is_required: `{{x}} เป็นสิ่งจำเป็น`,
  phone_number: 'หมายเลขโทรศัพท์',
  phone_num_x_max: `หมายเลขโทรศัพท์สูงสุด {{x}} หลัก`,
  email_sent: `ส่งอีเมลแล้ว กรุณาตรวจสอบอีเมลของคุณ`,
  enter_valid_email: `กรุณากรอกอีเมลที่ถูกต้อง`,
  confirm: `ยืนยัน`,
  password_atleast_6_characters: `รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร`,
  password_reset_success: `รีเซ็ตรหัสผ่านสำเร็จ!`,
  new_password: `รหัสผ่านใหม่`,
  bank: 'ธนาคาร',
  bank_transfer: `โอนเงินผ่านธนาคาร`,
  bank_name: `ชื่อธนาคาร`,
  bank_branch: `สาขาธนาคาร`,
  pay_id: `รหัสการชำระเงิน`,
  account_name: `ชื่อบัญชี`,
  account_number: `หมายเลขบัญชี`,
  drop_or_select: `ลากหรืเลือกไฟล์`,
  drop_files_here: `ลากไฟล์ที่นี่`,
  transfer_to: `โอนเงินไปยัง`,
  upload_receipt: `อัปโหลดใบเสร็จ`,
  select_bonus: `เลือกโบนัส`,
  no_promotion: `ไม่มีโปรโมชั่น`,
  please_upload_receipt: `กรุณาอัปโหลดใบเสร็จ`,
  bank_account: `บัญชีธนาคาร`,
  add_account: `เพิ่มบัญชี`,
  account_holder_name: `ชื่อเจ้าของบัญชี`,
  name_of_the_account_holder: `ชื่อของเจ้าของบัญชี`,
  fill_in_bank_account: `กรอกข้อมูลบัญชีธนาคาร`,
  withdraw_information: `ข้อมูลการถอน`,
  note: `หมายเหตุ`,
  amount_withdrawn: `จำนวนเงินที่ถอน`,
  amount_no_exceed_balance: `จำนวนเงินที่ถอนต้องไม่เกินยอดเงินที่มีอยู่`,
  minimum_withdraw_amount_is_x: `จำนวนเงินถอนขั้นต่ำคือ {{x}}`,
  transaction_history: `ประวัติการทำธุรกรรม`,
  date_from: `วันที่จาก`,
  date_to: `วันที่ถึง`,
  account_name_must_be_4: `ชื่อบัญชีต้องมีความยาวมากกว่า 4 ตัวอักษร`,
  account_number_must_be_x: `หมายเลขบัญชีต้องมีความยาว 10-14 ตัวอักษร`,
  minimum_length_is_x: `ความยาวขั้นต่ำคือ {{x}}`,
  maximum_length_is_x: `ความยาวสูงสุดคือ {{x}}`,
  payment_method: `วิธีการชำระเงิน`,
  mode: `โหมด`,
  no_bank_account: `คุณไม่มีบัญชีเพื่อถอนเงิน กรุณาเพิ่มบัญชี`,
  please_select_bank: `กรุณาเลือกบัญชีธนาคาร`,

  bet_history: `ประวัติการเดิมพัน`,
  game_provider: `ผู้ให้บริการเกม`,
  bet_count: `จำนวนเดิมพัน`,
  win_loss: `ชนะ/แพ้`,
  rebate: `เงินคืน`,
  turnover: `ยอดหมุนเวียน`,
  game_category: `หมวดหมู่เกม`,

  you_have_x_unread_messages: `คุณมี {{x}} ข้อความที่ยังไม่ได้อ่าน`,
  deposit_amount_between_x_and_y: `จำนวนเงินฝากต้องอยู่ระหว่าง {{x}} และ {{y}}`,
  minimum_amount_is_x_y: `จำนวนเงินขั้นต่ำคือ {{x}} {{y}}`,

  // all
  all: `ทั้งหมด`,
  title: `ชื่อเรื่อง`,
  date: `วันที่`,
  type: `ประเภท`,
  status: `สถานะ`,
  remark: `หมายเหตุ`,
  category: `หมวดหมู่`,
  please_select_x: `กรุณาเลือก {{x}}`,
  save: `บันทึก`,

  change_password: `เปลี่ยนรหัสผ่าน`,
  current_password: `รหัสผ่านปัจจุบัน`,
  confirm_password: `ยืนยันรหัสผ่านใหม่`,
  submit: `ส่ง`,
  password_changed: `เปลี่ยนรหัสผ่านแล้ว`,
  x_must_be_y_characters: `{{x}} ต้องมีความยาวอย่างน้อย {{y}} ตัวอักษร`,
  reset_password: `รีเซ็ตรหัสผ่าน`,
  casino: `คาสิโน`,
  slots: `สล็อต`,
  live_casino: `คาสิโนสด`,
  fishing: `ตกปลา`,
  sports: `กีฬา`,
  cards: `ไพ่`,
  clear: `ล้าง`,
  search: `ค้นหา`,
  new: `ใหม่`,
  logout: `ออกจากระบบ`,
  choose_date: `เลือกวันที่`,
  select_both_date: `เลือกวันที่จากและถึง`,
  from: `จาก`,
  to: `ถึง`,
  apply: `สมัคร`,
  promotions: `โปรโมชั่น`,
  learn_more: `เรียนรู้เพิ่มเติม`,
  password_doesnt_match: `รหัสผ่านไม่ตรงกัน`,
  cancel: `ยกเลิก`,
  confirm_to_pay: `ยืนยันการชำระเงิน`,
  deposit_amount: `จำนวนเงินฝาก`,
  loading_please_wait: `กำลังโหลด กรุณารอสักครู่`,
  account: `บัญชี`,
  profile: `โปรไฟล์`,
  bank_list: `รายชื่อธนาคาร`,
  in_maintenance: `อยู่ในระหว่างการบำรุงรักษา`,
  birthday: `วันเกิด`,
  birthday_bonus: `กรอกวันเกิดของคุณเพื่อรับโบนัส! 🎉🎁`,
  referral_code: `รหัสแนะนำ`,
  referral: `การแนะนำ`,
  my_referral: `การแนะนำของฉัน`,
  my_claim: `การเรียกร้องของฉัน`,
  claim_profit: `เรียกร้องกำไร`,
  available_profit: `กำไรที่มีอยู่`,
  claimed_profit: `กำไรที่เรียกร้อง`,
  all_time_profit: `กำไรตลอดเวลา`,
  referral_note_on_x: `รับกำไรทุกครั้งที่เพื่อนของคุณเล่นที่ {{x}}`,
  tier: `ระดับ`,
  commission: `ค่าคอมมิชชั่น`,
  referred_member: `สมาชิกที่แนะนำ`,
  profit_earned: `กำไรที่ได้รับ`,
  account_information: `ข้อมูลบัญชี`,
  invite_friends: `เชิญเพื่อน`,
  how_it_work: `มันทำงานอย่างไร?`,
  invite_note: `รับโบนัสการแนะนำพิเศษเมื่อเพื่อนของคุณลงทะเบียนโดยใช้รหัสแนะนำของคุณ!`,
  share_via: `แชร์ผ่าน`,
  referral_link: `ลิงก์แนะนำ`,
  total_profit: `กำไรรวม`,
  copied: `คัดลอกแล้ว`,
  nothing_to_claim: `ไม่มีอะไรให้เรียกร้อง`,
  claim_history: `ประวัติการเรียกร้อง`,
  downline: `สายงาน`,
  last_x_digit_bank_ref_number: `เลขอ้างอิงธนาคาร  {{x}} หลักสุดท้าย`,
  bank_ref_number_validation_x: `หมายเลขอ้างอิงธนาคารเป็นสิ่งจำเป็นและต้องมีความยาว {{x}} ตัวอักษร`,
  sort: 'เรียง',
  login_directly: `เข้าสู่ระบบโดยตรงด้วย`,
  our_game_provides: `ผู้ให้บริการเกมของเรา`,
  refer_and_reward: `แนะนำและรับรางวัล`,
  linked_successfully_x: `เชื่อมโยงสำเร็จด้วย {{x}}! กรุณาลงทะเบียนบัญชีของคุณเป็นครั้งแรก`,
  more_x_of_y: `มากกว่า {{x}}/{{y}}`,
  default: `ค่าเริ่มต้น`,
  promotion: `โปรโมชั่น`,
  daily_mission: 'ภารกิจประจำวัน',
  agent: 'ตัวแทน',
  contact_us: 'ติดต่อเรา',
  download: 'ดาวน์โหลด',
  cash_claim: 'เรียกร้องเงินสด',
  demo: 'เดโม',
  favorites: 'รายการโปรด',
  popular: 'ยอดนิยม',
  claim_bonus: `เรียกร้องโบนัส`,
  insufficient_balance: `ยอดเงินไม่เพียงพอ`,
  currently_displaying: 'ขณะนี้แสดง {{x}} {{y}} เกมจาก {{z}}',
  all_x: 'ทั้งหมด {{x}}',
  no_results: 'ไม่พบผลลัพธ์',
  search_games: 'ค้นหาเกม',
  please_scan_using_your: `กรุณาสแกนโดยใช้`,
  vip_level: `ระดับ VIP`,
  bonus_direct: `โบนัสตรง`,
  rebate_level: `ระดับเงินคืน`,
  vip_header: `การเดิมพันทั้งหมดที่วางบนเครื่องสล็อต เกมบอร์ดและไพ่ การตกปลา วิดีโอ กีฬา และเกมลอตเตอรี่ที่ Yum998 จะถูกรวมเข้าด้วยกันอย่างถาวร เดิมพันที่ถูกต้อง = รายได้ถาวรและโชคลาภ!`,
  vip_example: `
  ตัวอย่างที่ 1: สมาชิกที่มียอดฝากสะสมถึง 1 ล้าน จะถึงระดับ VIP 2 รับโบนัส R$210 และเงินคืน 3.50% เมื่อพวกเขามียอดฝากสะสมถึง 6 ล้าน จะถึงระดับ VIP 3 และรับโบนัส R$800 พร้อมเงินคืน 4%`,
  activity_rules: `กฎกิจกรรม:`,
  activity_rules_1: `1. จำเป็นต้องมีโบนัสทั้งหมดที่มี x3 Winover เพื่อขอถอนเงิน`,
  activity_rules_2: `2. กรุณาเรียกร้องโบนัสเงินคืนภายในกำหนดเวลา หากคุณล่าช้า จะถือว่าทิ้ง`,
  activity_rules_3: `3. การเข้าร่วมกิจกรรมของสมาชิกจะถูกนับโดยอัตโนมัติโดยระบบ หากมีข้อโต้แย้ง ผลการตรวจสอบของ Yum998 จะมีผล`,
  activity_rules_4: `4. หากคุณลืมบัญชีสมาชิก/รหัสผ่าน กรุณาติดต่อ "บริการลูกค้าออนไลน์ 24 ชั่วโมง" เพื่อช่วยคุณกู้คืนข้อมูลบัญชี`,
  activity_rules_5: `5. Yum998 ขอสงวนสิทธิ์ในการเปลี่ยน แก้ไข หรือยกเลิกโปรโมชั่นนี้ได้ตลอดเวลา`,
  activity_rules_6: `6. ห้ามบันทึกเกมฟรี ซื้อเกมฟรี`,
  activity_rules_7: `7. ไม่สามารถรวมกับโบนัสใด ๆ`,
  activity_rules_8: `8. ถอนสูงสุดต่อการฝากคือ R$100,000`,
  event_instructions: 'คำแนะนำกิจกรรม',
  agent_p1: 'แชร์ลิงก์เฉพาะของคุณในแอปและโซเชียลมีเดีย',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube และอื่น ๆ รีบเชิญทุกคน สมาชิกที่ลงทะเบียนผ่านลิงก์เฉพาะของคุณจะกลายเป็นตัวแทนของคุณโดยตรง แต่โปรดระวังเพราะสมาชิกใหม่ที่คุณเชิญต้องเป็นของจริงและถูกต้อง',
  agent_step1:
    'รับเชิญเพื่อนเมื่อการฝากครั้งแรกสำเร็จ คุณสามารถชนะโบนัส R$5 ตัวอย่างเช่น หากคุณเชิญ 10 คนสำหรับการฝากครั้งแรก คุณสามารถรับ R$50 ยิ่งคุณเชิญคนมากเท่าไหร่ คุณก็จะได้รับโบนัสมากขึ้นเท่านั้น คุณสามารถดูประวัติของคุณและลงทะเบียนในหน้าโปรโมชั่นโบนัสและค่าคอมมิชชั่นสูง',
  agent_step2:
    'หากแขกของคุณเดิมพัน R$1 หรือมากกว่า คุณสามารถเพลิดเพลินกับค่าคอมมิชชั่นสูง! คุณสามารถรับค่าคอมมิชชั่นตลอดชีพสูงสุด 5% และการเชิญตลอดชีวิต! ระบบจะชำระค่าคอมมิชชั่นของวันก่อนในเวลา 7 โมงเช้าของวันถัดไป',
  agent_step2_1: 'วิธีการรับ: เข้าสู่ระบบ - โปรโมชั่นเชิญ - เก็บค่าคอมมิชชั่น',
  agent_table1: 'อัตราค่าคอมมิชชั่นการเดิมพันสำหรับสล็อต การตกปลา และบล็อกเชนมีดังนี้:',
  agent_table1_1: 'ลูกค้าฝาก 20 เดิมพัน 200',
  person: 'คน',
  agent_table2_title1: 'การเดิมพันสมาชิก',
  agent_table2_title2: 'เฉพาะเกมสล็อต',
  agent_table2_example:
    'ตัวอย่าง: คุณมีสมาชิก 100 คน และมูลค่าที่แท้จริงของการเดิมพันโดยประมาณอยู่ที่ 1 ล้านเรอัลต่อวัน ค่าคอมมิชชั่นที่คุณได้รับในวันนั้นคือ: 1,000,000 x 1.20% 12,000 เรอัล รายได้ต่อเดือน 100,000 เป็นเรื่องง่ายมาก',
  reminder: 'การแจ้งเตือน',
  agent_reminder:
    'บัญชีสมาชิกที่มี IP เดียวกัน อุปกรณ์เดียวกัน ชื่อ หมายเลขบัตรธนาคาร และข้อมูลอื่น ๆ สามารถเข้าร่วมได้เพียงครั้งเดียว และผู้ใดที่ละเมิดกฎจะไม่ได้รับประโยชน์จากโบนัสนี้ หรือกลุ่มจะถูกยึดและบัญชีจะถูกระงับถาวร',
  agent_step3_1:
    'การเข้าร่วมกิจกรรมของสมาชิกจะถูกนับโดยอัตโนมัติโดยระบบ หากมีข้อโต้แย้ง ผลการวิเคราะห์ที่ดำเนินการโดย Yum998 จะมีผล',
  agent_step3_2:
    'หากคุณลืมบัญชีสมาชิก/รหัสผ่าน กรุณาติดต่อทีมบริการลูกค้า 24 ชั่วโมงของเราเพื่อช่วยคุณกู้คืนข้อมูลบัญชี',
  agent_step3_3: 'Yum998 ขอสงวนสิทธิ์ในการเปลี่ยน แก้ไข หรือยกเลิกโปรโมชั่นได้ตลอดเวลา',
  agent_step3_4: 'ตัวแทนสามารถรับโบนัสค่าคอมมิชชั่นในรูปแบบเงินสดหรือเครดิตในกระเป๋า',
  agent_step3_5: 'ห้ามบันทึกเกมฟรี ซื้อเกมฟรี',
  agent_step3_6: 'ไม่สามารถรวมกับโบนัสและการฝากใด ๆ',
  agent_step3_7: 'ใช้ได้เฉพาะสำหรับเกมสล็อต',
  promo_concluded: 'โปรโมชั่นสิ้นสุดแล้ว! กลับมาตรวจสอบอีกครั้งในวันพรุ่งนี้!',
  can_only_claim: 'สามารถเรียกร้องโบนัสได้เฉพาะ',
  please_login: 'กรุณาเข้าสู่ระบบก่อนเพื่อเรียกร้องโบนัส!',
  back_to_home: 'กลับไปที่หน้าแรก',
  bonus_claimed: 'โบนัสถูกเรียกร้องแล้ว!',
  terms_n_conditions: `ข้อกำหนดและเงื่อนไข`,
  claim_now: `เรียกร้องตอนนี้`,
  the_activity_x_in: `กิจกรรม {{x}} ใน`,
  starts: `เริ่ม`,
  ends: `สิ้นสุด`,
  list_of_winners: `รายชื่อผู้ชนะ`,
  days: `วัน`,
  hours: `ชั่วโมง`,
  minutes: `นาที`,
  seconds: `วินาที`,
  total_amount_received: `จำนวนเงินรวมที่ได้รับ`,
  deposit_fee: `ค่าธรรมเนียมการฝาก`,
  get: 'รับ',
  apply_now: `สมัครตอนนี้`,
  number_exists: 'หมายเลขโทรศัพท์นี้ถูกลงทะเบียนแล้ว!',
  number_not_exists: 'หมายเลขโทรศัพท์นี้ไม่ได้ลงทะเบียน!',
  payment_draft: 'หากคุณยืนยันว่าคุณได้ชำระเงินแล้ว กรุณารอสักครู่เนื่องจากการชำระเงินอาจยังอยู่ในระหว่างดำเนินการ',
  my_downline: 'สายงานของฉัน',
  downline_name: 'ชื่อสายงาน',
  date_joined: 'วันที่เข้าร่วม',
  deposit_amount_x_days: 'จำนวนเงินฝาก ({{x}} วัน)',
  dont_show_again: 'ไม่แสดงอีก',
  next: 'ถัดไป',
  close: 'ปิด',
  no_balance: 'ไม่มียอดเงิน',
  menu: `เมนู`,
  vip_club: `คลับ VIP`,
  home: `หน้าแรก`,
  lobby: `ล็อบบี้`,
  show_all: `แสดงทั้งหมด`,
  game_name: `ชื่อเกม`,
  sub_filters: `ตัวกรองย่อย`,
  contact_us_24: `ติดต่อเรา 24 ชั่วโมง`,
  live_chat: `แชทสด`,
  chat_now: `แชทตอนนี้`,
  gaming_license: `ใบอนุญาตการเล่นเกม`,
  certification: `การรับรอง`,
  security: `ความปลอดภัย`,
  threatmetrix: `ThreatMetrix`,
  gaming_license_caption: `Yum998 เป็นหน่วยงานที่ได้รับใบอนุญาตและควบคุมโดยรัฐบาลของคูราเซาและดำเนินการอย่างถูกต้องตามกฎหมายภายใต้ใบอนุญาตหลักของผู้ให้บริการเกม N.V #365/JAZ`,
  no_limits: `ไม่มีขีดจำกัด`,
  vip_description_no_limits: `เรามีบริการ VIP ส่วนตัวที่มีเงื่อนไขการเล่นเกมที่ไม่เหมือนใครสำหรับผู้เล่นทุกคนในคลับ VIP ตอนนี้คุณสามารถเล่นโดยไม่ต้องกังวล! มันง่ายมาก - เล่นเพื่อความตื่นเต้น ปรับปรุงทักษะการเล่นเกมของคุณ เพลิดเพลินกับเวลาของคุณและไม่มีขีดจำกัดในการชนะ!`,
  financial_privileges: `สิทธิพิเศษทางการเงิน`,
  vip_description_financial_privileges: `คลับ VIP ยินดีต้อนรับผู้เล่นทุกคนที่ต้องการรับบริการ VIP คุณภาพสูง สิทธิพิเศษ โปรโมชั่นพิเศษ และผลประโยชน์มีให้คุณที่เว็บไซต์ของเรา! สถานะผู้เล่น VIP จะปลดล็อกขีดจำกัดการถอนเงินที่สูงขึ้นในระยะเวลาสั้น ๆ! เพลิดเพลินไปกับมัน!`,
  personal_manager: `ผู้จัดการส่วนตัว`,
  vip_description_personal_manager: `คุณต้องการได้รับข้อดีอะไรเมื่อคุณกลายเป็นผู้เล่น VIP? แบ่งปันความคิดของคุณกับผู้จัดการส่วนตัวของคุณและบอกเราว่าคุณต้องการเห็นอะไรเพิ่มเติมที่เว็บไซต์ของเรา! เราเปิดรับข้อเสนอแนะที่ดีเสมอ!`,
  vip_promotions: `โปรโมชั่น VIP`,
  vip_description_vip_promotions: `คุณต้องการรับโปรโมชั่นที่ยอดเยี่ยมมากขึ้นหรือไม่? ผู้เล่น VIP ที่มีน้ำหนักมากเพลิดเพลินกับสิทธิประโยชน์เหล่านี้และอีกมากมายเป็นรางวัลสำหรับความภักดี! เป็นหนึ่งในพวกเขา!`,
  withdraw_limit: `ขีดจำกัดการถอน`,
  monthly: `รายเดือน`,
  weekly: `รายสัปดาห์`,
  annual: `รายปี`,
  cashback: `เงินคืน`,
  personal_account_manager: `ผู้จัดการบัญชีส่วนตัว`,
  yes: `ใช่`,
  join_the_vip: `เข้าร่วมโปรแกรม VIP ตอนนี้!`,
  join_now: `เข้าร่วมตอนนี้`,
  play_the_way_you_want: `เล่นในแบบที่คุณต้องการ`,
  more_info: `ข้อมูลเพิ่มเติม`,
  nothing_to_show: `ไม่มีอะไรให้แสดง`,
  remarks: `หมายเหตุ`,
  password: `รหัสผ่าน`,
  back: `กลับ`,
  new_to_x: `ใหม่สำหรับ {{x}} หรือไม่`,
  create_an_account: `สร้างบัญชี`,
  withdraw_amount: `จำนวนเงินที่ถอน`,
  balance: `ยอดเงิน`,
  bank_bsb: `รหัส BSB ธนาคาร`,
  enter_bank_branch: `กรอกสาขาธนาคาร`,
  enter_pay_id: `กรอกรหัสการชำระเงิน`,
  level: `ระดับ`,
  claimed: `เรียกร้องแล้ว`,
  not_found: `ไม่พบ`,
  become_a_vip: `กลายเป็น VIP`,
  otp_not_found: `OTP ยังไม่ได้ตั้งค่า`,
  resend_again: `ส่งอีกครั้ง`,
  how_to_get_referral_bonus: 'วิธีรับโบนัสการแนะนำเพื่อน?',
  steps_to_claim: 'ขั้นตอนในการเรียกร้องโบนัส',
  share_your_referral_code:
    '1. แชร์รหัสแนะนำของคุณกับเพื่อนเพื่อให้ลงทะเบียนบัญชีผ่าน Facebook, Twitter หรือ WhatsApp.',
  after_friend_register:
    '2. หลังจากที่เพื่อนลงทะเบียนกับ Yum998 ทั้งผู้แนะนำและสมาชิกที่แนะนำต้องทำการฝากเงินเพื่อเรียกร้องโบนัสนี้.',
  refer_a_friend_bonus: '3. การคำนวณโบนัสการแนะนำเพื่อน:',
  turnover_played: 'ยอดหมุนเวียนที่เล่น x ค่าคอมมิชชั่น % = โบนัสการแนะนำเพื่อน',
  example: 'ตัวอย่าง:',
  turnover_formula_x: 'ยอดหมุนเวียน (1,000,000) x 0.002% (ค่าคอมมิชชั่น %) = 2,000{{x}}',
  note_bonus_only: '*หมายเหตุ: โบนัสสามารถเรียกร้องได้ในวันถัดไปหลังจากเวลา 12:00 น.',
  note_bonus_only_x: '*หมายเหตุ: โบนัสสามารถเรียกร้องได้ในวันถัดไปหลังจาก {{x}}',
  access_dashboard: '4. เข้าถึงแดชบอร์ดเพื่อตรวจสอบกำไรที่มีสิทธิ์ ระดับค่าคอมมิชชั่น ประวัติการเรียกร้อง และสายงาน.',
  click_this_button_to_claim: 'คลิกปุ่มนี้เพื่อเรียกร้องโบนัสการแนะนำเพื่อน',
  commision_tier: 'ระดับค่าคอมมิชชั่น',
  member_downline: 'สมาชิกสายงาน',
  verified_by_play_protect: `ได้รับการตรวจสอบโดย Play Protect`,
  reviews: `26K รีวิว`,
  reviews_value: `4M+`,
  downloads: `ดาวน์โหลด`,
  rated_for: `Rated for 18+`,
  install: `ติดตั้ง`,
  add_to_wishlist: `เพิ่มในรายการโปรด`,
  about_this_app: `เกี่ยวกับแอปนี้`,
  app_description_1: `ยินดีต้อนรับสู่ Yum998 แพลตฟอร์มคาสิโนออนไลน์ชั้นนำของบังกลาเทศ ที่ซึ่งความตื่นเต้นและโอกาสในการชนะไม่มีที่สิ้นสุด! ไม่ว่าคุณจะเป็นแฟนเกมคาสิโนคลาสสิกหรือการเดิมพันที่ทันสมัยและมีความเสี่ยงสูง เรามีสิ่งที่เหมาะกับทุกคน สัมผัสความตื่นเต้นจากเกมที่หลากหลายของเรา รวมถึงสล็อต แบล็คแจ็ค รูเล็ต โป๊กเกอร์ และอื่น ๆ ทั้งหมดจากความสะดวกสบายของอุปกรณ์มือถือของคุณ.`,
  app_description_2: `ที่ Yum998 เราให้ความสำคัญกับความปลอดภัยและประสบการณ์การเล่นเกมของคุณ แพลตฟอร์มของเราได้รับใบอนุญาตและปลอดภัยอย่างเต็มที่ เพื่อให้แน่ใจว่ามีการเล่นอย่างยุติธรรมและการเล่นเกมอย่างรับผิดชอบตลอดเวลา เราใช้เทคโนโลยีขั้นสูงเพื่อปกป้องข้อมูลส่วนบุคคลของคุณและมอบประสบการณ์การเล่นเกมที่ราบรื่นด้วยการฝากเงินที่รวดเร็ว การถอนเงินที่รวดเร็ว และการสนับสนุนลูกค้า 24/7.`,
  why_choose_brand: `ทำไมต้องเลือก Yum998?`,
  reason_1: `การเลือกเกมที่หลากหลายจากผู้ให้บริการเกมชั้นนำ`,
  reason_2: `อินเทอร์เฟซที่ใช้งานง่ายพร้อมการนำทางที่สะดวก`,
  reason_3: `โบนัสและโปรโมชั่นพิเศษที่ออกแบบมาเฉพาะสำหรับคุณ`,
  reason_4: `ตัวเลือกการชำระเงินที่ปลอดภัยสำหรับการทำธุรกรรมที่รวดเร็วและปลอดภัย`,
  reason_5: `มีให้บริการในภาษาบังกาลีและภาษาอังกฤษเพื่อตอบสนองความต้องการของคุณ`,
  app_description_3: `เข้าร่วมกับผู้เล่นที่พึงพอใจหลายพันคนในวันนี้และเข้าร่วมประสบการณ์คาสิโนออนไลน์ที่เชื่อถือได้ที่สุดในบังกลาเทศ! ไม่ว่าคุณจะมาที่นี่เพื่อความตื่นเต้นของเกมหรือโอกาสในการชนะรางวัลใหญ่ Yum998 คือประตูสู่ความบันเทิงที่ไม่มีที่สิ้นสุด.`,
  optional: 'ตัวเลือก',
  deposit_from_bank: 'ฝากจากธนาคาร',
  app_download: `ดาวน์โหลดแอป`,
  download_message: `ดาวน์โหลดแอปของเราวันนี้!`,
  only_x_country_allowed: 'อนุญาตให้ใช้หมายเลข {{x}} เท่านั้น',
  number_verified: 'หมายเลขโทรศัพท์ได้รับการตรวจสอบแล้ว',
  otp_expired: 'OTP หมดอายุ กรุณารีเฟรชและลองอีกครั้ง',
  captcha_check_failed: 'การตรวจสอบ CAPTCHA ล้มเหลว',
  affiliate: `พันธมิตร`,
  promo: `โปรโมชั่น`,
  input_otp: 'กรอกรหัส OTP',
  send_again_in_x: 'ส่งอีกครั้งใน {{x}}',
  otp_sent_enter_code_password: 'รหัสยืนยันได้ถูกส่งแล้ว กรุณากรอกรหัสและรหัสผ่านใหม่ของคุณเพื่อดำเนินการต่อ.',
  edit: `แก้ไข`,
  footer_text1: `Yum998: แพลตฟอร์มการเดิมพันและความบันเทิงที่ดีที่สุดในบังกลาเทศ`,
  footer_text2: `Yum998 คือจุดหมายปลายทางที่ดีที่สุดสำหรับการเดิมพันและความบันเทิงระดับพรีเมียมในบังกลาเทศ ในฐานะแพลตฟอร์มชั้นนำของประเทศ Yum998 มอบประสบการณ์ที่ปลอดภัย ใช้งานง่าย และมีฟีเจอร์ครบครันที่ตอบสนองความต้องการของผู้ที่ชื่นชอบกีฬาและผู้ที่มองหาความบันเทิง.`,
  footer_text3: `ด้วย Yum998 คุณจะได้รับสิทธิ์เข้าถึง:`,
  footer_text4: `• โอกาสในการเดิมพันที่น่าตื่นเต้น: เดิมพันในคริกเก็ต ฟุตบอล และกีฬาหลายประเภทด้วยอัตราต่อรองที่แข่งขันได้.`,
  footer_text5: `• คาสิโนและเกมสด: สำรวจเกมคาสิโนระดับสูงและประสบการณ์ดีลเลอร์สดเพื่อความบันเทิงที่ดื่มด่ำ.`,
  footer_text6: `• อินเทอร์เฟซที่ใช้งานง่าย: เพลิดเพลินกับการนำทางที่ราบรื่น ความเร็วในการโหลดที่รวดเร็ว และการออกแบบที่ใช้งานง่าย.`,
  footer_text7: `• การทำธุรกรรมที่ปลอดภัย: ฝากและถอนเงินอย่างปลอดภัยโดยใช้วิธีการชำระเงินที่เชื่อถือได้.`,
  footer_text8: `• การสนับสนุน 24/7: รับความช่วยเหลือตลอด 24 ชั่วโมงจากทีมสนับสนุนที่ทุ่มเทของเรา.`,
  footer_text9: `ที่ Yum998 เราเชื่อในมากกว่าการเดิมพัน - เรามุ่งมั่นที่จะสร้างช่วงเวลาแห่งความสนุกและความทรงจำที่ไม่อาจลืมเลือน! เข้าร่วมครอบครัวของผู้ใช้ที่ตื่นเต้นและค้นหาว่าทำไม Yum998 ถึงเป็นแพลตฟอร์มที่ดีที่สุดสำหรับการเดิมพันและความบันเทิงในบังกลาเทศ เรารอคอยที่จะให้คุณเข้าร่วมความสนุก.`,
  footer_text10: `เริ่มต้นการเดินทางสู่ชัยชนะของคุณวันนี้ที่ Yum998.`,
  enter_promo_code: 'กรอกรหัสโปรโมชั่น',
  promo_code: 'รหัสโปรโมชั่น',
  bonus_unlocked: 'โปรโมชั่นถูกปลดล็อก!',
  x_claimed: '{{x}} ถูกเรียกร้อง!',
  apply_code: 'ใช้รหัส',
  please_login_to_enter_promo: 'กรุณาเข้าสู่ระบบเพื่อกรอกและใช้รหัส',
  maximum_withdraw_amount_is_x: `จำนวนเงินถอนสูงสุดคือ {{x}}`,
  follow_us: `ติดตามเรา`,
  logout_confirmation: 'ยืนยันการออกจากระบบ',
  are_you_sure_to_logout: 'คุณแน่ใจหรือว่าต้องการออกจากระบบ?',
  select_language: 'เลือกภาษา',
  welcome_to_best_casino: 'ยินดีต้อนรับสู่คาสิโนออนไลน์ที่ดีที่สุด!',
  welcome_back_good_luck: 'ยินดีต้อนรับกลับ ขอให้โชคดี!',
  fill_in_phone_number: 'กรอกหมายเลขโทรศัพท์',
  currency_language: 'สกุลเงินและภาษา',
  no: 'ไม่',
  verify_now: 'ยืนยันตอนนี้',
  phonenumber_verification: 'การตรวจสอบหมายเลขโทรศัพท์',
  must_start_with_x: 'ต้องเริ่มต้นด้วย {{x}}',
  phonenumber_not_verified:
    'หมายเลขโทรศัพท์ยังไม่ได้รับการตรวจสอบ! กรุณาตรวจสอบหมายเลขโทรศัพท์ของคุณในหน้าโปรไฟล์บัญชี',
  proceed: 'ดำเนินการต่อ',
  leaderboard: 'กระดานผู้นำ',
  winnings: 'เงินรางวัล',
  download_app: `ดาวน์โหลดแอป`,
  press_to_install: `กดปุ่มเพื่อติดตั้งแอป!`,
  download_app_now: `ดาวน์โหลดแอปตอนนี้!`,
  enhance_playing: `ปรับปรุงประสบการณ์การเล่นของคุณ`,
  highlights: 'ไฮไลท์',
  refer_a_friend: `แนะนำเพื่อน`,
  history: `ประวัติ`,
  change_language: `เปลี่ยนภาษา`,
  contact: `ติดต่อ`,
  responsible_for_betting: `รับผิดชอบต่อการเดิมพัน`,
  licenses_and_certificates: `ใบอนุญาตและใบรับรอง`,
  click: `คลิก`,
  line: `ไลน์`,
  contact_teller: `ติดต่อเจ้าหน้าที่`,
  profit: `กำไร`,
  live_transactions: 'ธุรกรรมสด',
  before_that: 'ก่อนหน้านั้น',
  select_date: `เลือกวันที่`,
  adjustment: `การปรับ`,
  choose_deposit_method: 'เลือกวิธีการฝากเงิน',
  change_method: 'เปลี่ยนวิธีการ',
  condition: `เงื่อนไข`,
  enter_the_deposit_amount: 'กรอกจำนวนเงินที่คุณต้องการฝาก',
  select_amount: 'เลือกจำนวน',
  enter_amount_withdraw: 'กรอกจำนวนเงินที่คุณต้องการถอน',
  your_bank_account: 'บัญชีธนาคารของคุณ',
  your_current_balance: 'ยอดเงินปัจจุบันของคุณ',
  x_games: '{{x}} เกม',
  edit_account_phone: `แก้ไขบัญชี / โทรศัพท์`,
  edit_password: `แก้ไขรหัสผ่าน`,
  must_start_with: `หมายเลขโทรศัพท์ต้องมีอย่างน้อย 10 หลักและเริ่มต้นด้วย (06 หรือ 08 หรือ 09)`,
  please_select_a_bank: `กรุณาเลือกธนาคาร`,
  contact_customer_forgot_password: 'กรุณาติดต่อฝ่ายสนับสนุนลูกค้าเพื่อรีเซ็ตรหัสผ่านของคุณ ขอบคุณ!',
  member_level: 'ระดับสมาชิก',
  points_required: 'คะแนนที่ต้องการ',
  reward: 'รางวัล',
  mission: 'ภารกิจ',
  seven_day_challenge: 'ความท้าทาย 7 วัน',
  missed: 'พลาด',
  day: 'วัน',
  achievements: 'ภารกิจ',
  rewards: 'รางวัล',
  challenges: 'ความท้าทาย',
  under_maintenance: 'อยู่ระหว่างการบำรุงรักษา',
  reward_password: 'รหัสรางวัล',
  please_input_reward_password: 'กรุณาใส่รหัสรางวัลเพื่อดำเนินการต่อ',
  redeem_now: 'แลกรางวัลตอนนี้',
  scan_to_pay: `สแกนชำระแล้ว`,
  click_here: `คลิกตรงนี้`,
  always_choose_bank: `เลือกธนาคารของท่านก่อนฝากทุกครั้ง`,
  deposit_note_txt_1: 'ใช้บัญชีที่ลงทะเบียนสำหรับการทำธุรกรรมเท่านั้น.',
  missions: `ภารกิจ`
};

export default th;
